// List of Indian states
export const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

// List of countries (partial list - add more as needed)
export const countries = [
  "India",
  "Afghanistan",
  "Australia",
  "Bangladesh",
  "Bhutan",
  "Canada",
  "China",
  "France",
  "Germany",
  "Indonesia",
  "Japan",
  "Malaysia",
  "Maldives",
  "Nepal",
  "New Zealand",
  "Pakistan",
  "Russia",
  "Singapore",
  "Sri Lanka",
  "Thailand",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
];
